module.exports = __webpack_public_path__ + "img/f.44e76a21.jpg";